import { RootState } from "../store";

export const getAllOfficers = (state: RootState) => state.officer.allOfficers;
export const getOfficer = (state: RootState) => state.officer.officer;
export const getCreatedOfficer = (state: RootState) =>
  state.officer.createdOfficer;
export const getDeletedOfficer = (state: RootState) =>
  state.officer.deletedOfficer;
export const getUpdatedOfficer = (state: RootState) =>
  state.officer.updatedOfficer;
export const getOfficerPasswordReset = (state: RootState) =>
  state.officer.passwordReset;
export const getOfficerById = (state: RootState) => (id: string) => {
  return state.officer.allOfficers.data?.results.find((f) => f.uid === id);
};
